module.exports = __webpack_public_path__ + "static/media/bus-icon.28a01ec8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/bus-icon.svg
// module id = 729
// module chunks = 0